const isNotNull = str => str && str !== ''
import Vue from 'vue'
export const keepAliveMixin = {
    created() {
        const { $route: { meta: { keepAlive } } = { meta: {} }, $options: { name } } = this
        if (keepAlive && isNotNull(name)) {
            this.$bus.$on(name, this._keepAliveAction)
            this.$store.commit('addCachePageName', name)
        }
    },
    activated() {
    },
    methods: {
        _keepAliveAction(params = undefined) {
        }
    },
    beforeDestroy() {
        const { $route: { meta: { keepAlive } } = { meta: {} }, $options: { name } } = this
        this.$bus.$off(name, this._keepAliveAction)
    },
    destroyed() {

    }
}

export const scrollBehavior = (store) => {
    return function (to, from, savedPosition) {
        // console.log(to) // to：要进入的目标路由对象，到哪里去
        // console.log(from) // from：离开的路由对象，哪里来
        // console.log(savedPosition) // savePosition：会记录滚动条的坐标，点击前进/后退的时候记录值{x:?,y:?}
        // 从第二页返回首页时savedPosition为undefined
        if (savedPosition || typeof savedPosition === 'undefined') //后退
        {
            //后退到缓存页面，那么这里需要删除上一个页面的缓存，因为你要是再次打开，肯定要获取最新的页面数据 A-B-C 如果从C返回B肯定要把C的缓存删除，不然你从B-C，那就显示C的缓存了
            store.commit('delCachePageName', from.name);
            //后退滚动到上一次位置
            if (savedPosition) {
                return savedPosition
            }
        } else { //前进
            if (to.meta.nextStart) {
                store.commit('resetCachePageName', 'app')
                let timer = setInterval(() => {
                    store.commit('addCachePageName', to.name)
                    timer && clearTimeout(timer)
                }, 0);
            } else {
                //前进把前进的页面加入到要缓存的组件中
                store.commit('addCachePageName', to.name);
            }
            //前进滚动到顶部
            return { x: 0, y: 0 }
        }
        return savedPosition
    }
}
